import {useQuery} from "@tanstack/react-query";
import {readPurchaseOrderSubject} from "../../../../../api/purchase/PcsApi";

type Props = {
    param: { purchaseOrderId: number };
};

export const useReadPurchaseOrderSubject = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readPurchaseOrderSubject", param],
        queryFn: async () => await readPurchaseOrderSubject(param),
        select: (res) => res?.data.result ?? [],
        enabled: param.purchaseOrderId !== 0
    });

    return {data};
};
